import type { BankAccountDto, CurrencyDto } from '../types/coreApi-types'

/** The one currency a Danish domestic account (registration + account number) can be paid in. */
export const DOMESTIC_PAYOUT_CURRENCY_ISO_CODE = 'DKK'

/**
 * Whether a payout in `currency` has to go to a bank account registered by its IBAN. A Danish domestic account
 * is reachable only through Danish domestic clearing, which moves DKK alone — a EUR payout goes out by SEPA.
 * A crypto payout goes to a wallet, never a bank account.
 */
export const payoutRequiresIban = (currency: CurrencyDto) =>
  currency.currencyType === 'FiatCurrency' &&
  currency.isoCode !== DOMESTIC_PAYOUT_CURRENCY_ISO_CODE

/**
 * Whether a payout in `currency` can be sent to `bankAccount` — the web mirror of the API's
 * `BankAccountDetails.CanReceivePayoutIn`, which refuses the order otherwise. An account's details carry an
 * IBAN exactly when it was registered as an international (IBAN) account.
 */
export const canReceivePayoutIn = (
  bankAccount: BankAccountDto,
  currency: CurrencyDto
) =>
  !payoutRequiresIban(currency) || Boolean(bankAccount.bankAccountDetails.iban)
